



















































import { Component, mixins, Prop } from 'nuxt-property-decorator'
import { ISliderItem, ISliderSize } from '~/assets/interfaces/slider'
import MixinGeneral from '~/assets/mixins/general'
import { IStyle } from '~/assets/interfaces/classes'

@Component({
  components: {
    ComponentSliderSwiper: () =>
      import('~/components/slider/swiper/swiper.vue'),
    ComponentSliderSwiperSlide: () =>
      import('~/components/slider/swiper/slide.vue'),
    ComponentImage: () => import('~/components/images/image.vue'),
  },
})
export default class ComponentSliderStandard extends mixins(MixinGeneral) {
  @Prop({ type: [String, Number] }) readonly height!: string | number
  @Prop({ type: Number }) readonly autoplayDelay!: number
  @Prop({ type: String, default: 'type-1' }) readonly type!: string
  @Prop({ type: Array, default: [] }) readonly items!: ISliderItem[]
  @Prop({ type: Object }) readonly size!: ISliderSize
  @Prop({ type: Boolean, default: false }) readonly needPreload!: boolean

  private get styleInner() {
    const styles: IStyle = {}
    styles.paddingTop = (this.size.height / this.size.width) * 100 + '%'
    if (this.height) {
      styles.height = this.height + 'px'
      styles.maxHeight = this.height + 'px'
    }
    return styles
  }

  private get classType() {
    return {
      [this.$style.type1]: this.type === 'type-1',
      [this.$style.type2]: this.type === 'type-2',
    }
  }

  private shouldLazyLoad(index: number): boolean {
    return !(index === 0 && this.needPreload)
  }

  private fetchPriority(index: number): string {
    return index === 0 && this.needPreload ? 'high' : 'low'
  }
}
